import { createAction, handleActions } from 'redux-actions';

export const types = {
  handleLoginFormLoginRequest: 'HANDLE_LOGINFORM_LOGIN_REQUEST',
  handleLoginFormLoginRequesting: 'HANDLE_LOGINFORM_LOGIN_REQUESTING',
  handleLoginFormLoginResponse: 'HANDLE_LOGINFORM_LOGIN_RESPONSE',
  handleLoginFormLoginResponseError: 'HANDLE_LOGINFORM_LOGIN_RESPONSE_ERROR',
  handleLoginFormNeedsSync: 'HANDLE_LOGINFORM_NEEDS_SYNC',
};

export const handleLoginFormLoginRequest = createAction(types.handleLoginFormLoginRequest);

export const handleLoginFormLoginRequesting = createAction(types.handleLoginFormLoginRequesting);

export const handleLoginFormLoginResponse = createAction(types.handleLoginFormLoginResponse);

export const handleLoginFormLoginResponseError = createAction(types.handleLoginFormLoginResponseError);

export const handleLoginFormNeedsSync = createAction(types.handleLoginFormNeedsSync);

export const INITIAL_STATE = {
  username: '',
  rememberme: false,
  requesting: false,
  logged: false,
  userData: {},
  accessData: {},
  loginData: {},
  deviceData: {},
  needsSync: false,
  error: '',
};

export const loginFormReducer = handleActions(
  {
    [types.handleLoginFormLoginRequest]: (state, action) => ({
      ...state,
      username: action.username,
      requesting: true,
    }),
    [types.handleLoginFormLoginResponse]: (state, action) => ({
      ...state,
      userData: action.payload.userData,
      accessData: action.payload.accessData,
      loginData: action.payload.loginData,
      deviceData: action.payload.deviceData,
      needsSync: action.payload.needsSync,
      logged: action.payload.logged,
      session_info: action.payload.session_info,
      error: action.payload.error,
      requesting: false,
    }),
    [types.handleLoginFormLoginResponseError]: (state, action) => ({
      ...state,
      userData: action.payload.userData,
      accessData: action.payload.accessData,
      loginData: action.payload.loginData,
      deviceData: action.payload.deviceData,
      needsSync: false,
      logged: action.payload.logged,
      session_info: action.payload.session_info,
      error: action.payload.error,
      requesting: false,
    }),
    [types.handleLoginFormNeedsSync]: (state, action) => ({
      ...state,
      needsSync: action.payload.needsSync,
    }),
  },
  INITIAL_STATE
);
